import { render } from "./BlockStyledBar.vue?vue&type=template&id=1b10ccf9&scoped=true"
import script from "./BlockStyledBar.vue?vue&type=script&lang=js"
export * from "./BlockStyledBar.vue?vue&type=script&lang=js"

import "./BlockStyledBar.vue?vue&type=style&index=0&id=1b10ccf9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b10ccf9"]])

export default __exports__